import styled from '@emotion/styled';

const AppContentOuterWrapper = styled('div')({
  flex: 1,
});

export default AppContentOuterWrapper;
